
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICreateFeaturedLobbyRequest, Lobby } from '../../../../Utils/_models/lobbies.model';
import { ITheme } from '../../../../Utils/_models/themes.model';


@Component({
  selector: 'app-lobby-form',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './lobby-form.component.html',
  styleUrl: './lobby-form.component.css'
})
export class LobbyFormComponent implements OnInit {
  @Input() show = false;
  @Input() lobby: Lobby | null = null;
  @Input() themes: ITheme[] = [];
  @Input() themesLoading = false;
  @Input() creating = false;
  
  @Output() closeForm = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<ICreateFeaturedLobbyRequest>();

  isEditMode = false;
  formData: ICreateFeaturedLobbyRequest = this.getEmptyForm();

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges() {
    this.initializeForm();
  }

  private initializeForm() {
    if (this.lobby) {
      this.isEditMode = true;
      this.formData = this.mapLobbyToForm(this.lobby);
    } else {
      this.isEditMode = false;
      this.formData = this.getEmptyForm();
    }
  }

  private getEmptyForm(): ICreateFeaturedLobbyRequest {
    return {
      name: '',
      description: '',
      themeId: '',
      entryFee: 0,
      maxParticipants: 0,
      location: {
        coordinates: { latitude: 0, longitude: 0 },
        city: '',
        state: '',
        country: ''
      },
      recurringSchedule: { dailyTime: '' },
      roundQuestions: []
    };
  }

  private mapLobbyToForm(lobby: Lobby): ICreateFeaturedLobbyRequest {
    return {
      name: lobby.theme,
      description: '',
      themeId: '',
      entryFee: lobby.price,
      maxParticipants: lobby.capacity,
      location: {
        coordinates: { latitude: 0, longitude: 0 },
        city: '',
        state: '',
        country: ''
      },
      recurringSchedule: { dailyTime: '' },
      roundQuestions: []
    };
  }

  addRoundQuestion() {
    const nextNumber = (this.formData.roundQuestions?.length || 0) + 1;
    this.formData.roundQuestions = [
      ...(this.formData.roundQuestions || []),
      { roundNumber: nextNumber, questionText: '' }
    ];
  }

  removeRoundQuestion(index: number) {
    if (!this.formData.roundQuestions) return;
    this.formData.roundQuestions = this.formData.roundQuestions.filter((_, i) => i !== index);
    this.formData.roundQuestions = this.formData.roundQuestions.map((q, i) => ({ ...q, roundNumber: i + 1 }));
  }

  onClose() {
    this.closeForm.emit();
  }

  onSubmit() {
    const f = this.formData;
    const hasLocation = !!(f.location && f.location.city && f.location.country);
    const hasCoords = !!(f.location && f.location.coordinates &&
      typeof f.location.coordinates.latitude === 'number' && typeof f.location.coordinates.longitude === 'number');

    if (!f.name || !f.themeId || f.entryFee === null || f.entryFee === undefined || f.maxParticipants <= 0 || !hasLocation || !hasCoords) {
      console.warn('Please fill all required fields (name, themeId, entryFee, maxParticipants, location, coordinates).');
      return;
    }

    this.submitForm.emit(this.formData);
  }

  get modalTitle(): string {
    return this.isEditMode ? 'Edit Lobby' : 'Create Featured Lobby';
  }

  get submitButtonText(): string {
    if (this.creating) {
      return this.isEditMode ? 'Updating…' : 'Creating…';
    }
    return this.isEditMode ? 'Update' : 'Create';
  }
}